import type { IActiveWorkout, ITrainingRecord } from '@/hooks/useAppState';
import { isTrainingRecordComplete } from '@/lib/trainingRecordCompletion';
import type { WorkoutDraft } from './workoutDraft';

/** Use the existing quit-record semantics; a completed summary must never be recorded twice. */
export function interruptedWorkoutRecord(draft: WorkoutDraft, active: IActiveWorkout, date: string,
  names: { courseName: string; dayName: string }, now = Date.now()): ITrainingRecord | null {
  const completedSets = draft.records.reduce((sum, exercise) => sum + exercise.sets.filter(set => set.completed).length, 0);
  if (!completedSets || draft.finishedRecordId) return null;
  const totalSets = draft.records.reduce((sum, exercise) => sum + exercise.sets.length, 0);
  return {
    id: `rec-${now}`, date, courseId: draft.courseId, courseName: names.courseName,
    dayId: draft.dayId, dayName: names.dayName,
    durationMin: Math.round((now - active.startTimestamp) / 60000) || 5,
    totalSets, completedSets, exercises: draft.records,
    sessionStatus: isTrainingRecordComplete({ totalSets, completedSets, exercises: draft.records }) ? 'completed' : 'partial',
    volumeReductionPercent: parseInt(new URLSearchParams(draft.route.split('?')[1]).get('reduction') || '0'),
  };
}
